import * as Backbone from "backbone";
import * as _ from "lodash";
import {CachingCollection} from "./_BaseCollection";
import {DashboardCategory} from "../models/DashboardCategory";

interface DashboardCategoryCollectionOptions {
    dashboardId: number;
    tabId?: number;
}

export class DashboardCategoryCollection extends CachingCollection<DashboardCategory> {

    urlRoot = '/api/v1/dashboards/';

    dashboardId: number;
    tabId?: number;

    url = () => {
        var url = this.urlRoot + this.dashboardId + '/categories';
        if (this.tabId) {
            url += '?tabId=' + this.tabId;
        }
        return url;
    };

    constructor(initialModels: Object[] | any[], options: DashboardCategoryCollectionOptions) {
        super(initialModels, _.extend({model: DashboardCategory}, options));
        this.dashboardId = options.dashboardId;
        this.tabId = options.tabId;
    }

    comparator = (model) => {
        return model.get('order');
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/DashboardCategories.ts